import {ROLES} from '@/constants/roles'
export default {
  header: 'Plantillas',
  navLink: '/app/templates',
  roles: [ROLES.coordinator, ROLES.superadmin],
  children: []
}
